import { Component, h, Prop, Element } from '@stencil/core';

/**
 * COMPNAME is for displaying information about an article within a journal issue's table of contents. It can contain child components such as headings, rich text content, aafp-journal-article-icon-list, and aafp-journal-article-tag-list. The image is optional.
 */
@Component({
  tag: 'aafp-journal-issue-toc-article',
  shadow: false,
})
export class AafpJournalIssueTocArticle {
  /**
   * For the thumbnail image
   */
  @Prop() imgSrc: string;

  /**
   * For the thumbnail image's alt text
   */
  @Prop() imgAlt: string;

  @Element() element: HTMLElement;

  render() {
    return (
      <article class="adl-journal-issue-toc-article adl-space__sm__m-t-md adl-space__sm__m-b-lg">
        {this.imgSrc && (
          <div class="adl-journal-issue-toc-article__image">
            <img src={this.imgSrc} alt={this.imgAlt} />
          </div>
        )}
        <div class="adl-journal-issue-toc-article__content">
          <slot />
        </div>
      </article>
    );
  }
}
